import { render, staticRenderFns } from "./AddRoles.vue?vue&type=template&id=1a5ed2a6&scoped=true"
import script from "./AddRoles.vue?vue&type=script&lang=ts"
export * from "./AddRoles.vue?vue&type=script&lang=ts"
import style0 from "./AddRoles.vue?vue&type=style&index=0&id=1a5ed2a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5ed2a6",
  null
  
)

export default component.exports